import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { TableSkeleton } from '@/components/ui/skeleton';

const ReportsPage = lazy(() => import('@/pages/reports'));

export const Route = createFileRoute('/reports')({
  component: function ReportsRoute() {
    return (
      <Suspense fallback={<TableSkeleton />}>
        <ReportsPage />
      </Suspense>
    );
  },
});
